import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import marcaService from '../services/marcaService';
import listingService from '../services/listingService';
import { useAuth } from '../context/AuthContext';
import LoginModal from '../components/LoginModal';
import '../sass/PublicarPage.scss';

// ── Comunas de Chile agrupadas por región (legacy, reemplazado por API) ────────
const COMUNAS = [
  // Región Metropolitana
  ...["Alhué","Buin","Calera de Tango","Cerrillos","Cerro Navia","Colina","Conchalí","Curacaví",
      "El Bosque","El Monte","Estación Central","Huechuraba","Independencia","Isla de Maipo",
      "La Cisterna","La Florida","La Granja","La Pintana","La Reina","Lampa","Las Condes",
      "Lo Barnechea","Lo Espejo","Lo Prado","Macul","Maipú","María Pinto","Melipilla","Ñuñoa",
      "Padre Hurtado","Paine","Pedro Aguirre Cerda","Peñaflor","Peñalolén","Pirque","Providencia",
      "Pudahuel","Puente Alto","Quilicura","Quinta Normal","Recoleta","Renca","San Bernardo",
      "San Joaquín","San José de Maipo","San Miguel","San Pedro","San Ramón","Santiago",
      "Talagante","Tiltil","Vitacura"].map(n => ({ name: n, group: "Región Metropolitana" })),
  // Valparaíso
  ...["Algarrobo","Calle Larga","Cartagena","Casablanca","Catemu","El Quisco","El Tabo",
      "Hijuelas","Juan Fernández","La Calera","La Cruz","La Ligua","Limache","Llaillay",
      "Los Andes","Nogales","Olmué","Panquehue","Papudo","Petorca","Puchuncaví","Putaendo",
      "Quilpué","Quillota","Rinconada","San Antonio","San Esteban","San Felipe","Santa María",
      "Santo Domingo","Valparaíso","Villa Alemana","Viña del Mar","Zapallar"].map(n => ({ name: n, group: "Valparaíso" })),
  // Biobío
  ...["Alto Biobío","Antuco","Arauco","Cabrero","Cañete","Chiguayante","Concepción","Contulmo",
      "Coronel","Curanilahue","Florida","Hualpén","Hualqui","Laja","Lebu","Los Álamos",
      "Los Ángeles","Lota","Mulchén","Nacimiento","Negrete","Penco","Quilaco","Quilleco",
      "San Pedro de la Paz","San Rosendo","Santa Bárbara","Talcahuano","Tirúa","Tomé",
      "Tucapel","Yumbel"].map(n => ({ name: n, group: "Biobío" })),
  // La Araucanía
  ...["Angol","Carahue","Cholchol","Collipulli","Cunco","Curacautín","Curarrehue","Ercilla",
      "Freire","Galvarino","Gorbea","Lautaro","Loncoche","Lonquimay","Los Sauces","Lumaco",
      "Melipeuco","Nueva Imperial","Padre las Casas","Perquenco","Pitrufquén","Pucón","Purén",
      "Renaico","Saavedra","Temuco","Teodoro Schmidt","Toltén","Traiguén","Victoria","Vilcún",
      "Villarrica"].map(n => ({ name: n, group: "La Araucanía" })),
  // Los Lagos
  ...["Ancud","Castro","Chaitén","Chonchi","Cochamó","Curaco de Vélez","Dalcahue","Fresia",
      "Frutillar","Futaleufú","Hualaihué","Llanquihue","Los Muermos","Maullín","Osorno",
      "Palena","Puerto Montt","Puerto Octay","Puerto Varas","Puqueldón","Purranque","Puyehue",
      "Queilén","Quellón","Quemchi","Quinchao","Río Negro","San Juan de la Costa",
      "San Pablo"].map(n => ({ name: n, group: "Los Lagos" })),
  // Maule
  ...["Cauquenes","Chanco","Colbún","Constitución","Curepto","Curicó","Empedrado","Linares",
      "Longaví","Molina","Parral","Pelarco","Pelluhue","Pencahue","Rauco","Retiro","Romeral",
      "Sagrada Familia","San Clemente","San Javier","San Rafael","Talca","Teno","Vichuquén",
      "Villa Alegre","Yerbas Buenas"].map(n => ({ name: n, group: "Maule" })),
  // O'Higgins
  ...["Chimbarongo","Chépica","Codegua","Coinco","Coltauco","Doñihue","Graneros","La Estrella",
      "Las Cabras","Litueche","Lolol","Machalí","Malloa","Marchigüe","Mostazal","Nancagua",
      "Navidad","Olivar","Palmilla","Paredones","Peralillo","Peumo","Pichidegua","Pichilemu",
      "Placilla","Pumanque","Quinta de Tilcoco","Rancagua","Rengo","Requínoa","San Fernando",
      "San Vicente","Santa Cruz"].map(n => ({ name: n, group: "O'Higgins" })),
  // Coquimbo
  ...["Andacollo","Canela","Combarbalá","Coquimbo","Illapel","La Higuera","La Serena",
      "Los Vilos","Monte Patria","Ovalle","Paiguano","Punitaqui","Río Hurtado","Salamanca",
      "Vicuña"].map(n => ({ name: n, group: "Coquimbo" })),
  // Antofagasta
  ...["Antofagasta","Calama","María Elena","Mejillones","Ollagüe","San Pedro de Atacama",
      "Sierra Gorda","Taltal","Tocopilla"].map(n => ({ name: n, group: "Antofagasta" })),
  // Los Ríos
  ...["Corral","Futrono","La Unión","Lago Ranco","Lanco","Los Lagos","Máfil","Mariquina",
      "Paillaco","Panguipulli","Río Bueno","Valdivia"].map(n => ({ name: n, group: "Los Ríos" })),
  // Atacama
  ...["Alto del Carmen","Caldera","Chañaral","Copiapó","Diego de Almagro","Freirina","Huasco",
      "Tierra Amarilla","Vallenar"].map(n => ({ name: n, group: "Atacama" })),
  // Ñuble
  ...["Bulnes","Chillán","Chillán Viejo","Cobquecura","Coelemu","Coihueco","El Carmen","Ninhue",
      "Ñiquén","Pemuco","Pinto","Portezuelo","Quillón","Quirihue","Ránquil","San Carlos",
      "San Fabián","San Ignacio","San Nicolás","Treguaco","Yungay"].map(n => ({ name: n, group: "Ñuble" })),
  // Tarapacá
  ...["Alto Hospicio","Camiña","Colchane","Huara","Iquique","Pica","Pozo Almonte"].map(n => ({ name: n, group: "Tarapacá" })),
  // Arica y Parinacota
  ...["Arica","Camarones","General Lagos","Putre"].map(n => ({ name: n, group: "Arica y Parinacota" })),
  // Aysén
  ...["Aysén","Chile Chico","Cisnes","Cochrane","Coyhaique","Guaitecas","Lago Verde",
      "Río Ibáñez","Tortel"].map(n => ({ name: n, group: "Aysén" })),
  // Magallanes
  ...["Antártica","Cabo de Hornos","Laguna Blanca","Natales","Porvenir","Primavera",
      "Punta Arenas","Río Verde","San Gregorio","Timaukel","Torres del Paine"].map(n => ({ name: n, group: "Magallanes" })),
];

const YEARS = (() => {
  const y = [];
  for (let i = new Date().getFullYear(); i >= 1930; i--) y.push(i);
  return y;
})();

const CURRENT_YEAR = new Date().getFullYear();

function normalize(s) {
  return s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

// ── Autocomplete de comunas ────────────────────────────────────────────────────
function ComunaAutocomplete({ value, onChange }) {
  const [query, setQuery] = useState(value || '');
  const [open, setOpen] = useState(false);
  const [hiIdx, setHiIdx] = useState(-1);
  const wrapRef = useRef(null);

  const filtered = query.length === 0
    ? COMUNAS
    : COMUNAS.filter(c => normalize(c.name).includes(normalize(query)));

  const select = useCallback((name) => {
    setQuery(name);
    onChange(name);
    setOpen(false);
  }, [onChange]);

  useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleKeyDown = (e) => {
    const items = filtered;
    if (e.key === 'ArrowDown') { e.preventDefault(); setHiIdx(i => Math.min(i + 1, items.length - 1)); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setHiIdx(i => Math.max(i - 1, 0)); }
    else if (e.key === 'Enter' && hiIdx >= 0) { e.preventDefault(); select(items[hiIdx].name); }
    else if (e.key === 'Escape') setOpen(false);
  };

  // render grouped items
  const renderItems = () => {
    let lastGroup = null;
    return filtered.map((c, i) => {
      const groupHeader = c.group !== lastGroup
        ? <div key={'g-' + c.group + i} className="ac-group">{c.group}</div>
        : null;
      lastGroup = c.group;
      return [
        groupHeader,
        <div
          key={c.name + i}
          className={`ac-item${hiIdx === i ? ' highlighted' : ''}`}
          onMouseDown={(e) => { e.preventDefault(); select(c.name); }}
        >
          {c.name}
        </div>
      ];
    });
  };

  return (
    <div className="autocomplete-wrap" ref={wrapRef}>
      <input
        type="text"
        value={query}
        placeholder="Escribe o elige tu comuna..."
        autoComplete="off"
        onChange={e => { setQuery(e.target.value); onChange(e.target.value); setOpen(true); setHiIdx(-1); }}
        onFocus={() => setOpen(true)}
        onKeyDown={handleKeyDown}
      />
      {open && filtered.length > 0 && (
        <div className="autocomplete-list">
          {renderItems()}
        </div>
      )}
    </div>
  );
}

// ── Componente principal ───────────────────────────────────────────────────────
export default function PublicarPage() {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const { user } = useAuth();

  const [step, setStep] = useState(1);
  const [showLogin, setShowLogin] = useState(false);
  const [makers, setMakers] = useState([]);
  const [models, setModels] = useState([]);
  const [regions, setRegions] = useState([]);
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [listingId, setListingId] = useState(null);

  const [form, setForm] = useState({
    condition: null,
    ownerCount: '',
    makerId: '',
    makerName: '',
    modelId: '',
    modelName: '',
    year: '',
    mileage: '',
    transmission: '',
    fuelType: '',
    price: '',
    regionId: '',
    cityId: '',
    contactName: '',
    contactPhone: '',
    description: '',
    photos: [],
    photoPreviews: [],
  });

  const [errors, setErrors] = useState({});

  const API = process.env.REACT_APP_API_URL || 'http://localhost:8080';

  useEffect(() => {
    marcaService.getMakers().then(setMakers).catch(() => {});
    fetch(`${API}/api/locations/regions`)
      .then(r => r.json()).then(setRegions).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!form.regionId) { setCities([]); return; }
    fetch(`${API}/api/locations/cities?regionId=${form.regionId}`)
      .then(r => r.json()).then(setCities).catch(() => {});
  }, [form.regionId]); // eslint-disable-line react-hooks/exhaustive-deps

  const set = (field, value) =>
    setForm(prev => ({ ...prev, [field]: value }));

  const makerIsOther = form.makerId === 'otro';
  const modelIsOther = form.modelId === 'otro';

  const handleMakerChange = (e) => {
    const name = e.target.value;
    const selected = makers.find(m => m.name === name);
    setForm(prev => ({
      ...prev,
      makerId:   name,
      makerName: name === 'otro' ? '' : name,
      modelId:   '',
      modelName: '',
    }));
    setModels(selected?.models || []);
  };

  const handleModelChange = (e) => {
    const option = e.target.options[e.target.selectedIndex];
    set('modelId', option.value);
    set('modelName', option.value === 'otro' ? '' : option.text);
  };

  const handleFiles = (files) => {
    const newFiles = Array.from(files).slice(0, 10 - form.photos.length);
    const previews = newFiles.map(f => URL.createObjectURL(f));
    setForm(prev => ({
      ...prev,
      photos: [...prev.photos, ...newFiles],
      photoPreviews: [...prev.photoPreviews, ...previews],
    }));
  };

  const removePhoto = (idx) => {
    setForm(prev => ({
      ...prev,
      photos: prev.photos.filter((_, i) => i !== idx),
      photoPreviews: prev.photoPreviews.filter((_, i) => i !== idx),
    }));
  };

  // ── Validación paso 1 ──
  const validateStep1 = () => {
    const errs = {};
    if (!form.condition) errs.condition = 'Selecciona si el auto es usado o nuevo';
    if (!form.price || Number(form.price) <= 0) errs.price = 'Ingresa el precio';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  // ── Validación paso 3 ──
  const validateStep3 = () => {
    const errs = {};
    if (!form.contactName.trim())  errs.contactName  = 'Ingresa tu nombre';
    if (!form.contactPhone.trim()) errs.contactPhone = 'Ingresa tu teléfono';
    if (!form.regionId)            errs.regionId     = 'Selecciona tu región';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const goStep = (n) => {
    if (n === 2 && !validateStep1()) return;
    if (n === 4) {
      if (!validateStep3()) return;
      if (!user) { setShowLogin(true); return; }
      handleSubmit();
      return;
    }
    setStep(n);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const payload = {
        firebaseUid:   user?.uid   || null,
        contactEmail:  user?.email || null,
        makerId:      null,
        makerName:    form.makerName || null,
        modelId:      null,
        modelName:    form.modelName || null,
        year:         form.year ? Number(form.year) : null,
        condition:    form.condition,
        mileage:      form.mileage ? Number(form.mileage) : null,
        transmission: form.transmission || null,
        fuelType:     form.fuelType || null,
        price:        Number(form.price),
        regionId:     form.regionId ? Number(form.regionId) : null,
        cityId:       form.cityId   ? Number(form.cityId)   : null,
        contactName:  form.contactName,
        contactPhone: form.contactPhone,
        description:  form.description || null,
      };
      const result = await listingService.createListing(payload);
      setListingId(result.id);

      if (form.photos.length > 0) {
        await listingService.uploadImages(result.id, form.photos);
      }

      setStep(4);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      console.error('Error al publicar', err);
      alert('Hubo un problema al publicar. Intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setForm({
      condition: null, ownerCount: '', makerId: '', makerName: '', modelId: '',
      modelName: '', year: '', mileage: '', transmission: '', fuelType: '',
      price: '', regionId: '', cityId: '', contactName: '', contactPhone: '',
      description: '', photos: [], photoPreviews: [],
    });
    setErrors({});
    setListingId(null);
    setStep(1);
  };

  // ── Render steps ──────────────────────────────────────────────────────────
  return (
    <div className="publicar-page">

      {showLogin && (
        <LoginModal
          onClose={() => setShowLogin(false)}
          onSuccess={() => { setShowLogin(false); handleSubmit(); }}
        />
      )}

      {/* Banner CTA */}
      <div className="cta-banner">
        <div className="cta-icon">🚗</div>
        <div className="cta-text">
          <h3>Publica tu auto gratis</h3>
          <p>Sin costos, sin letra chica. Tu anuncio aparece en minutos.</p>
        </div>
      </div>

      {/* Progress */}
      {step < 4 && (
        <div className="progress-wrap">
          {[
            { n: 1, label: 'Tu auto' },
            { n: 2, label: 'Fotos' },
            { n: 3, label: 'Contacto' },
          ].map(({ n, label }) => (
            <div key={n} className={`step-dot ${step === n ? 'active' : step > n ? 'done' : ''}`}>
              <div className="dot-circle">{step > n ? '✓' : n}</div>
              <div className="dot-label">{label}</div>
            </div>
          ))}
        </div>
      )}

      {/* ── PASO 1 – Tu auto ── */}
      {step === 1 && (
        <div className="pub-card">
          <div className="card-title">¿Qué auto vendes?</div>
          <div className="card-subtitle">Ingresa los datos básicos de tu vehículo</div>

          {/* Condición */}
          <div className="condition-section" style={{ marginBottom: 6 }}>
            <label>Condición</label>
            <div className="condition-toggle">
              <button
                className={`cond-btn${form.condition === 'USED' ? ' selected' : ''}${errors.condition ? ' error-ring' : ''}`}
                onClick={() => { set('condition', 'USED'); setErrors(e => ({ ...e, condition: null })); }}
              >
                <span className="icon">🔑</span> Usado
              </button>
              <button
                className={`cond-btn${form.condition === 'NEW' ? ' selected' : ''}${errors.condition ? ' error-ring' : ''}`}
                onClick={() => { set('condition', 'NEW'); setErrors(e => ({ ...e, condition: null })); }}
              >
                <span className="icon">✨</span> Nuevo
              </button>
            </div>
            {errors.condition && <div className="condition-error">{errors.condition}</div>}
          </div>


          <div className="fields-row">
            {/* Marca */}
            <div className="pub-field">
              <label>Marca</label>
              {makerIsOther ? (
                <input
                  type="text"
                  placeholder="Escribe la marca..."
                  className={errors.makerId ? 'invalid' : ''}
                  value={form.makerName}
                  onChange={e => { set('makerName', e.target.value); setErrors(err => ({ ...err, makerId: null })); }}
                  autoFocus
                />
              ) : (
                <div className="select-wrap">
                  <select
                    className={errors.makerId ? 'invalid' : ''}
                    value={form.makerId}
                    onChange={e => { handleMakerChange(e); setErrors(err => ({ ...err, makerId: null })); }}
                  >
                    <option value="">Selecciona...</option>
                    {makers.map(m => (
                      <option key={m.name} value={m.name}>{m.name}</option>
                    ))}
                    <option value="otro">Otro</option>
                  </select>
                </div>
              )}
              {makerIsOther && (
                <button
                  type="button"
                  style={{ fontSize: 12, marginTop: 4, background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', padding: 0 }}
                  onClick={() => { setForm(prev => ({ ...prev, makerId: '', makerName: '', modelId: '', modelName: '' })); setModels([]); }}
                >
                  ← Volver al listado
                </button>
              )}
              {errors.makerId && <div className="field-error">{errors.makerId}</div>}
            </div>

            {/* Modelo */}
            <div className="pub-field">
              <label>Modelo</label>
              {(makerIsOther || modelIsOther) ? (
                <input
                  type="text"
                  placeholder="Escribe el modelo..."
                  value={form.modelName}
                  onChange={e => set('modelName', e.target.value)}
                  autoFocus={!makerIsOther}
                />
              ) : (
                <div className="select-wrap">
                  <select value={form.modelId} onChange={handleModelChange} disabled={!form.makerId}>
                    <option value="">Selecciona...</option>
                    {models.map(m => (
                      <option key={m.name} value={m.id || m.name}>{m.name}</option>
                    ))}
                    {form.makerId && <option value="otro">Otro</option>}
                  </select>
                </div>
              )}
              {modelIsOther && !makerIsOther && (
                <button
                  type="button"
                  style={{ fontSize: 12, marginTop: 4, background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', padding: 0 }}
                  onClick={() => setForm(prev => ({ ...prev, modelId: '', modelName: '' }))}
                >
                  ← Volver al listado
                </button>
              )}
            </div>
          </div>

          <div className="fields-row">
            {/* Año */}
            <div className="pub-field">
              <label>Año</label>
              <div className="select-wrap">
                <select
                  className={errors.year ? 'invalid' : ''}
                  value={form.year}
                  onChange={e => { set('year', e.target.value); setErrors(err => ({ ...err, year: null })); }}
                >
                  <option value="">Selecciona...</option>
                  {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
                </select>
              </div>
              {errors.year && <div className="field-error">{errors.year}</div>}
            </div>

            {/* Kilómetros */}
            <div className="pub-field">
              <label>Kilómetros</label>
              <input
                type="number"
                min="0"
                placeholder="ej: 45000"
                value={form.mileage}
                onChange={e => set('mileage', e.target.value)}
              />
            </div>
          </div>

          <div className="fields-row">
            {/* Transmisión */}
            <div className="pub-field">
              <label>Transmisión</label>
              <div className="select-wrap">
                <select value={form.transmission} onChange={e => set('transmission', e.target.value)}>
                  <option value="">Selecciona...</option>
                  <option>Manual</option>
                  <option>Automático</option>
                </select>
              </div>
            </div>

            {/* Combustible */}
            <div className="pub-field">
              <label>Combustible</label>
              <div className="select-wrap">
                <select value={form.fuelType} onChange={e => set('fuelType', e.target.value)}>
                  <option value="">Selecciona...</option>
                  <option>Bencina</option>
                  <option>Diésel</option>
                  <option>Híbrido</option>
                  <option>Eléctrico</option>
                  <option>GLP / GNC</option>
                </select>
              </div>
            </div>
          </div>

          {/* Precio */}
          <div className="pub-field price">
            <label>Precio (CLP $)</label>
            <input
              type="number"
              min="0"
              placeholder="ej: 8500000"
              className={errors.price ? 'invalid' : ''}
              value={form.price}
              onChange={e => { set('price', e.target.value); setErrors(err => ({ ...err, price: null })); }}
            />
            {errors.price && <div className="field-error">{errors.price}</div>}
          </div>

          <div className="nav-btns">
            <div />
            <button className="btn-next" onClick={() => goStep(2)}>Siguiente →</button>
          </div>
        </div>
      )}

      {/* ── PASO 2 – Fotos ── */}
      {step === 2 && (
        <div className="pub-card">
          <div className="card-title">Agrega fotos</div>
          <div className="card-subtitle">Las publicaciones con fotos reciben 5× más contactos</div>

          {form.photoPreviews.length === 0 ? (
            <div className="photo-drop" onClick={() => fileInputRef.current?.click()}>
              <div className="drop-icon">📷</div>
              <p>Toca aquí para subir fotos</p>
              <small>JPG o PNG · Hasta 10 fotos · Máx. 5 MB c/u</small>
              <button
                className="btn-upload"
                onClick={e => { e.stopPropagation(); fileInputRef.current?.click(); }}
              >
                Elegir fotos
              </button>
            </div>
          ) : (
            <div className="photo-grid">
              {form.photoPreviews.map((src, i) => (
                <div key={i} className="photo-thumb">
                  <img src={src} alt={`foto-${i}`} />
                  <button className="remove-btn" onClick={() => removePhoto(i)}>✕</button>
                </div>
              ))}
              {form.photos.length < 10 && (
                <div className="photo-add" onClick={() => fileInputRef.current?.click()}>＋</div>
              )}
            </div>
          )}

          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            multiple
            style={{ display: 'none' }}
            onChange={e => handleFiles(e.target.files)}
          />

          <p className="photo-tip">
            💡 <span>Tip: fotografía el frente, costados y atrás del auto, y el interior. Con buena luz y fondo limpio.</span>
          </p>

          <div className="nav-btns">
            <button className="btn-back" onClick={() => setStep(1)}>← Atrás</button>
            <button className="btn-next" onClick={() => goStep(3)}>Siguiente →</button>
          </div>
        </div>
      )}

      {/* ── PASO 3 – Contacto ── */}
      {step === 3 && (
        <div className="pub-card">
          <div className="card-title">¿Cómo te contactamos?</div>
          <div className="card-subtitle">Datos para que los compradores se comuniquen contigo</div>

          <div className="fields-row">
            <div className="pub-field">
              <label>Tu nombre</label>
              <input
                type="text"
                placeholder="ej: Juan Pérez"
                className={errors.contactName ? 'invalid' : ''}
                value={form.contactName}
                onChange={e => { set('contactName', e.target.value); setErrors(err => ({ ...err, contactName: null })); }}
              />
              {errors.contactName && <div className="field-error">{errors.contactName}</div>}
            </div>
            <div className="pub-field">
              <label>Teléfono (WhatsApp)</label>
              <input
                type="tel"
                placeholder="+56 9 XXXX XXXX"
                className={errors.contactPhone ? 'invalid' : ''}
                value={form.contactPhone}
                onChange={e => { set('contactPhone', e.target.value); setErrors(err => ({ ...err, contactPhone: null })); }}
              />
              {errors.contactPhone && <div className="field-error">{errors.contactPhone}</div>}
            </div>
          </div>

          <div className="pub-field">
            <label>Región</label>
            <div className="select-wrap">
              <select
                className={errors.regionId ? 'invalid' : ''}
                value={form.regionId}
                onChange={e => {
                  set('regionId', e.target.value);
                  set('cityId', '');
                  setErrors(err => ({ ...err, regionId: null }));
                }}
              >
                <option value="">Selecciona tu región...</option>
                {regions.map(r => (
                  <option key={r.id} value={r.id}>{r.name}</option>
                ))}
              </select>
            </div>
            {errors.regionId && <div className="field-error">{errors.regionId}</div>}
          </div>

          <div className="pub-field">
            <label>Ciudad / Comuna</label>
            <div className="select-wrap">
              <select
                value={form.cityId}
                disabled={!form.regionId || cities.length === 0}
                onChange={e => set('cityId', e.target.value)}
              >
                <option value="">{form.regionId ? 'Selecciona tu ciudad...' : 'Primero selecciona una región'}</option>
                {cities.map(c => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="pub-field">
            <label>Descripción (opcional)</label>
            <textarea
              placeholder="Agrega detalles extra: estado del auto, accesorios, motivo de venta..."
              value={form.description}
              onChange={e => set('description', e.target.value)}
            />
          </div>

          <div className="nav-btns">
            <button className="btn-back" onClick={() => setStep(2)}>← Atrás</button>
            <button className="btn-next" onClick={() => goStep(4)} disabled={loading}>
              {loading ? 'Publicando...' : 'Publicar gratis 🎉'}
            </button>
          </div>
        </div>
      )}

      {/* ── PASO 4 – Éxito ── */}
      {step === 4 && (
        <div className="pub-card success-card">
          <span className="success-icon">🎉</span>
          <div className="success-title">¡Tu auto está publicado!</div>
          <p className="success-text">
            Tu anuncio ya está visible para miles de compradores en Chile.
            {listingId && ` (ID: #${listingId})`}
            <br />
            Te avisaremos por WhatsApp cuando alguien se interese.
          </p>
          <div className="success-actions">
            <button className="btn-primary-action" onClick={() => navigate('/')}>
              Explorar autos
            </button>
            <button className="btn-secondary-action" onClick={resetForm}>
              Publicar otro auto
            </button>
          </div>
        </div>
      )}

    </div>
  );
}
